import { useTranslation } from 'react-i18next'

function Header() {
  const { t } = useTranslation()

  const slides = [
    {
      image: '/assets/images/branding/headers/header1.jpeg',
      titles: [t('header.authentic'), t('header.custom'), t('header.jewelry')],
      description: t('header.authenticDescription'),
    },
    {
      image: '/assets/images/branding/headers/header2.jpeg',
      titles: [t('header.inspired'), t('header.by'), t('header.you')],
      description: t('header.inspiredDescription'),
    },
    {
      image: '/assets/images/branding/headers/header3.jpeg',
      titles: [t('header.created'), t('header.by'), t('header.us')],
      description: t('header.createdDescription'),
    },
  ]

  return (
    <header className="tc-header-style6">
      <div className="header-slider">
        <div className="swiper-wrapper">
          {slides.map((slide, index) => (
            <div className="swiper-slide" key={index}>
              <div className="slide-card">
                <img src={slide.image} alt={`slide-${index}`} className="bg" />
                <div className="content">
                  <div className="container">
                    <div className="info px-lg-4">
                      <div className="row align-items-center justify-content-center">
                        <div className="col-12 text-center">
                          <div className="title">
                            {slide.titles.map((title, i) => (
                              <h2 key={i}>{title}</h2>
                            ))}
                          </div>
                          <div className="description-wrapper marcellus">
                            <small className="sm-txt">{slide.description}</small>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>

      <div className="floating-contact">
        <p>
          <a href="#/">{t('header.contactPhone')}</a>
        </p>
        <p>
          <a href="#/">{t('header.contactEmail')}</a>
        </p>
      </div>

      <div className="arrows">
        <div className="swiper-button-prev"></div>
        <div className="swiper-button-next"></div>
      </div>
    </header>
  )
}

export default Header
